import React from 'react'
import Stars from './Stars'
import PrecisionBar from './PrecisionBar'

export default function Precision ({stars, preciseItems, byItem, assessmentSubtests}) {


  return (
    <div className="skill-box precision ">
      <div className="skill-information ">
        <h1 className="skill-name ">Precision</h1>
        <Stars stars={stars} />
        <p className="skill-description ">
          By eliminating incorrect answers, students improve their ability to guess correctly. This rating is based on the likelihood
          that your students made efficient use of the process of elimination. The graphic shows the estimated number of answers
          eliminated per question overall and in each subject area.
        </p>
		  </div>
      <PrecisionBar
        preciseItems={preciseItems}
        byItem={byItem}
        assessmentSubtests={assessmentSubtests}
      />
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/TestTaking/Precision.js